import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utilities';

const initialState = {
  ingredients: null,
  totalPrice: 4,
  isBuilding: false,
  ingredientPrices: {
    lettuce: 0.50,
    cheese: 0.4,
    meat: 1.30,
    bacon: 0.70
  }
}

const addIngredient = (state, action) => {
  const updatedIngredients_ADD = updateObject(state.ingredients, { [action.ingredient]: state.ingredients[action.ingredient] + 1 });
  const updatedPrice_ADD = state.totalPrice + state.ingredientPrices[action.ingredient];

  return updateObject(state, { ingredients: updatedIngredients_ADD, totalPrice: updatedPrice_ADD, isBuilding: true })
}

const removeIngredient = (state, action) => {
  const updatedIngredients_REMOVE = updateObject(state.ingredients, { [action.ingredient]: state.ingredients[action.ingredient] - 1 });
  const updatedPrice_REMOVE = state.totalPrice - state.ingredientPrices[action.ingredient];

  return updateObject(state, { ingredients: updatedIngredients_REMOVE, totalPrice: updatedPrice_REMOVE, isBuilding: true })
}

const setIsBuilding = (state, action) => {
  return updateObject(state, { isBuilding: action.isBuilding })
}

const setBurgerData = (state, action) => {
  let ingredients = {
    lettuce: 0,
    bacon: 0,
    cheese: 0,
    meat: 0
  };
  let price = 4;
  if (action.ingredients) {
    ingredients = {
      lettuce: action.ingredients.lettuce,
      bacon: action.ingredients.bacon,
      cheese: action.ingredients.cheese,
      meat: action.ingredients.meat
    };
    price += (ingredients.lettuce * state.ingredientPrices.lettuce)
      + (ingredients.bacon * state.ingredientPrices.bacon)
      + (ingredients.cheese * state.ingredientPrices.cheese)
      + (ingredients.meat * state.ingredientPrices.meat);
  }
  return updateObject(state, {
    ingredients: ingredients,
    totalPrice: price
  })
}

const burgerBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_INGREDIENT: return addIngredient(state, action);
    case actionTypes.REMOVE_INGREDIENT: return removeIngredient(state, action);
    case actionTypes.SET_BURGER_DATA: return setBurgerData(state, action);
    case actionTypes.SET_IS_BUILDING: return setIsBuilding(state, action);
    default: return state;
  }
}

export default burgerBuilderReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/burgerBuilderReducer.jsx